var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "EmdPanel",
    [
      _c(
        "EmdPanelSection",
        { attrs: { title: _vm.$t("self-declared-legal-representative") } },
        [
          _c(
            "EmdFormGroup",
            { attrs: { label: _vm.$t("self-declared-legal-representative") } },
            [
              _c(
                "EmdSelect",
                {
                  attrs: { name: "phone_type" },
                  model: {
                    value: _vm.selectedRepresentative,
                    callback: function ($$v) {
                      _vm.selectedRepresentative = $$v
                    },
                    expression: "selectedRepresentative",
                  },
                },
                _vm._l(
                  _vm.recipient.managing_partners,
                  function (partner, index) {
                    return _c(
                      "option",
                      { key: index, domProps: { value: index } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              partner.name ||
                                _vm.$t(
                                  "self-declared-legal-representative-placeholder",
                                  { number: index + 1 }
                                )
                            ) +
                            " "
                        ),
                      ]
                    )
                  }
                ),
                0
              ),
              _c("jade-checkbox", {
                attrs: {
                  id: "input-checkbox",
                  value: _vm.representativeCheckboxValue,
                  label: _vm.$t("confirmation-checkbox"),
                  "data-testid": "input-checkbox",
                },
                on: {
                  "update:value": function ($event) {
                    _vm.representativeCheckboxValue = $event
                  },
                  change: _vm.setRepresentative,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }